// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4":"61eded64","482":"338bd2a5","565":"aa654697","928":"11142994","933":"571b054a"}[chunkId] + ".css";
};